import React from 'react';
import PropTypes from 'prop-types';
import { EventCardSkeleton, TranslationProvider } from '@resy/ui-kitchen';
import './LayoutSkeletons.scss';

const LayoutSkeletons = ({ layout, icon }) => {
  const templateA = () => (
    <div className="LayoutSkeletons__templateA">
      <div className="content">
        <div className="image skeleton" />
        <div className="info">
          <div className="title skeleton" />
          <div className="text skeleton" />
          <div className="text skeleton" />
          <div className="text skeleton" />
          <div className="text skeleton" />
        </div>
      </div>
      <div className="cta skeleton" />
    </div>
  );

  const templateB = () => (
    <div className="LayoutSkeletons__templateB">
      <div className="content">
        <div className="logos">
          {[1, 2, 3, 4, 5, 6].map(() => (
            <div className="logo skeleton" />
          ))}
        </div>
        <div className="info">
          <div className="title skeleton" />
          <div className="text skeleton" />
          <div className="text skeleton" />
          <div className="text skeleton" />
        </div>
      </div>
      <div className="footer">
        <div className="cta skeleton" />
        <div className="cta skeleton" />
      </div>
    </div>
  );

  const templateC = () => (
    <div className="LayoutSkeletons__templateC">
      <div className="card">
        <div className="image skeleton" />
        <div className="calendar-icon" />
        <div className="info">
          <div className="soldout skeleton" />
          <div className="venue-name skeleton" />
          <div className="date skeleton" />
          <div className="date skeleton" />
          <div className="cta skeleton" />
        </div>
      </div>
      <div className="card">
        <div className="image skeleton" />
        <div className="calendar-icon" />
        <div className="info">
          <div className="soldout skeleton" />
          <div className="venue-name skeleton" />
          <div className="date skeleton" />
          <div className="date skeleton" />
          <div className="cta skeleton" />
        </div>
      </div>
    </div>
  );

  const templateD = () => (
    <div className="LayoutSkeletons__templateD">
      <div className="card">
        <EventCardSkeleton />
      </div>
      <div className="card">
        <EventCardSkeleton />
      </div>
    </div>
  );

  const templateE = () => (
    <div className="LayoutSkeletons__templateE">
      <div className="content">
        <div className="info">
          <div className="title skeleton" />
          <div className="text skeleton" />
          <div className="text skeleton" />
          <div className="text skeleton" />
          <div className="text skeleton" />
        </div>
      </div>
      <div className="cta skeleton" />
    </div>
  );

  const templateF = () => (
    <>
      {icon ? (
        <div className="LayoutSkeletons__templateF--image">
          <img src={icon} alt="" />
          <TranslationProvider translationKey="communication_loading_message">
            <p>Loading...</p>
          </TranslationProvider>
        </div>
      ) : (
        <div className="LayoutSkeletons__templateF">
          <div className="content">
            <div className="info">
              <div className="title skeleton" />
              <div className="text skeleton" />
              <div className="text skeleton" />
              <div className="text skeleton" />
              <div className="text skeleton" />
            </div>
          </div>
          <div className="cta skeleton" />
        </div>
      )}
    </>
  );

  const displayLayout = () => {
    switch (layout) {
      case 'templateA':
        return templateA();
      case 'templateB':
        return templateB();
      case 'templateC':
        return templateC();
      case 'templateD':
        return templateD();
      case 'templateE':
        return templateE();
      case 'templateF':
      default:
        return templateF();
    }
  };
  return displayLayout();
};

LayoutSkeletons.propTypes = {
  layout: PropTypes.string.isRequired,
  icon: PropTypes.string,
};

LayoutSkeletons.defaultProps = {
  icon: null,
};

export default LayoutSkeletons;
